import ApiService from './ApiService'
import Vue from "vue";
import VueAxios from "vue-axios";
import axios from "axios";

Vue.use(VueAxios, axios)

export const AuthenticationService = {

  baseURL: process.env.VUE_APP_RANU_URL,

  addAccessAuthorization (params) {
    return ApiService.post(`${this.baseURL}/v2/external/access/add-authorization-contact`, params)
  },

  authenticate (params) {
    return ApiService.post(`${this.baseURL}/v2/external/authorization`, params)
  },

  resendCode (accessCode) {
    return ApiService.post(`${this.baseURL}/v2/external/access/${accessCode.record_id}/resend-code/${accessCode.id}`)
  },

  validateCode (accessCode, params) {
    return ApiService.post(`${this.baseURL}/v2/external/access/${accessCode.record_id}/validate-code/${accessCode.id}`, params)
  },

  validateExternalRecord(processId, entityId, birthdate) {
    const params = {
      'processId': processId,
      'entityId': entityId,
      'birthdate': birthdate
    }
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${this.baseURL}/v2/external/access/validate-record`, {params: {...params}})
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}

export const RecordsService = {

  baseURL: process.env.VUE_APP_RANU_URL,

  copy (accessCode, user) {
    return ApiService.post(`${this.baseURL}/v2/records/${accessCode.record_id}`, {
      access_code_id: accessCode.id,
      entity_id: user.entity.id,
      user_id: user.id,
    })
  },

  get (slug, params = {}) {
    if(params.externalRecordPermission === undefined) {
      params.externalRecordPermission = false
    }

    return new Promise((resolve, reject) => {
      Vue.axios.get(`${this.baseURL}/v2/records/${slug}`, {params: {...params}})
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  store (params) {
    return ApiService.post(`${this.baseURL}/v2/records`, params)
  },

  update (resource, params) {
    return ApiService.put(`${this.baseURL}/v2/records/${resource}`, params)
  },

  destroy (resource) {
    return ApiService.delete(`${this.baseURL}/v2/records/${resource}`)
  }
}

export const ExamsService = {

  baseURL: process.env.VUE_APP_RANU_URL,

  store (slug, params) {
    return ApiService.post(`${this.baseURL}/v2/records/${slug}/exams`, params)
  },

  update (slug, resource, params) {
    return ApiService.put(`${this.baseURL}/v2/records/${slug}/exams/${resource}`, params)
  },

  destroy (slug, resource) {
    return ApiService.delete(`${this.baseURL}/v2/records/${slug}/exams/${resource}`)
  }
}

export const StatusesService = {

  baseURL: process.env.VUE_APP_RANU_URL,

  query (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/v2/statuses`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}

export const ExamTypesService = {

  baseURL: process.env.VUE_APP_RANU_URL,

  query (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/v2/exam-types`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}
